<template>
  <div id="app">
    
    <template>
      <router-view />
    </template>
  </div>
</template>


<script>
// import FormOptions from "@/class/FormOptions";

import { mapState } from "vuex";
export default {

 
  computed: {
    // ...mapState(["formOptions"]),
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      // this.$store.state.formOptions = new FormOptions();
      // console.log("this.$store.state.formOptions",this.$store.state.formOptions);
      // console.log("this.formOptions",this.formOptions);
    },
  },
};
</script>
<style lang="less">
#app {
  width: 100%;
  height: 100%;
}
</style>
